'use client';

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function NotFound() {
  const router = useRouter();
  const [title, setTitle] = useState('');

  useEffect(() => {
    const pageTitle = 'Page Not Found';
    document.title = pageTitle;
    setTitle(pageTitle); // Set it so it can be rendered in JSX
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-4">
      <h1 className="text-5xl font-bold text-red-500 mb-4">404</h1>
      <h2 className="text-2xl font-semibold mb-2">{title}</h2>
      <p className="text-muted-foreground mb-6">
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <button
        onClick={() => router.back()}
        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition"
      >
        Go Back
      </button>
    </div>
  );
}
